import { render, staticRenderFns } from "./PersonShortInfo.vue?vue&type=template&id=f45d4ffc"
import script from "./PersonShortInfo.vue?vue&type=script&lang=js"
export * from "./PersonShortInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports